var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavDeiNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "93B0ABE7-EA2B-42E3-9972-88202DDA4233") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -432.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8FA",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#344A5C",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 421.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavDocuments-Copy",
    transform: "translate(18.000000, 432.000000)",
    fill: "#979598",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5810769,8.69995965 C17.8210592,4.6043629 14.9899196,1.48877601 13.557683,2.06989296 C11.1254363,3.05990292 15.0065865,7.80772846 3.06091077,12.6622217 C2.02867816,13.0833371 1.76756442,14.7600206 2.19979099,15.7644752 C2.63090644,16.7667075 4.04203175,17.7656064 5.07426435,17.3467133 C5.25315504,17.2733792 5.90871719,17.062266 5.90871719,17.062266 C6.64539127,18.0522759 7.41651013,17.4656034 7.69095734,18.0933875 L8.97763695,21.0489728 C9.22097273,21.6067561 9.77208938,22.123428 10.1720934,21.9712043 L12.4498941,21.10564 C12.9698993,20.9078602 13.0932339,20.4434111 12.9343434,20.078963 C12.7632306,19.6845146 12.0610013,19.5689579 11.8598882,19.1089532 C11.6598862,18.6511709 11.0054351,17.1778227 10.8176555,16.7133736 C10.5620973,16.0822561 11.1054361,15.5678065 11.8954441,15.4866946 C17.3332766,14.9178 18.3499534,18.2778338 20.2010832,17.5244929 C21.6310976,16.9411537 21.3399835,12.792223 19.5810769,8.69995965 L19.5810769,8.69995965 Z M18.9688486,15.3400264 C18.6499565,15.4678055 16.5099349,13.782233 15.1432545,10.5988676 C13.775463,7.41772453 13.9476869,4.50991751 14.2654679,4.3799162 C14.5832489,4.25213714 16.6710477,6.28771317 18.0377281,9.46885628 C19.4055196,12.6499994 19.2866295,15.2100251 18.9688486,15.3400264 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDeiNormal);
export default __webpack_public_path__ + "static/media/NavDEINormal.b3e1080714e863b27b177787da6eb676.svg";
export { ForwardRef as ReactComponent };